import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { UnitKeysRedux } from '../Redux/UnitKeysRedux'

const unitKeysCrudObservable = createCRUDObservable({
  mainRedux: UnitKeysRedux,
  reduxPath: 'unitKeys',
})

export const unitKeysObservers = Object.assign({}, unitKeysCrudObservable.observers, {})

export const unitKeysEpic = combineEpics(
  unitKeysCrudObservable.epic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/UnitKeysObservable.js